<template>
  <div class="page-store-sellers">
    <PageBack :to="listRoute" />

    <PageHeader :title="$t('menu.store-sellers')">
      <template v-slot:actions>
        <ButtonLink
          size="m"
          icon="plus"
          color="grey"
          :to="createRoute"
        >
          {{ $t('store-sellers.create.title') }}
        </ButtonLink>
      </template>
    </PageHeader>

    <PageLoader v-if="sellerLoading && !sellers" />

    <TextSimple v-else-if="sellers && !sellers.items.length && !sellers.pagination?.totalCount">{{
      $t('global.no-results-found')
    }}</TextSimple>

    <TableSticky
      v-else-if="sellers"
      :fields="fields"
      :data="sellers.items"
      :pagination="sellers.pagination"
      :default-items-per-page="listQuery.itemsPerPage"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageBack from '@/components/ui/page/PageBack';
import PageHeader from '@/components/ui/page/PageHeader';
import PageLoader from '@/components/ui/page/PageLoader';
import ButtonLink from '@/components/ui/button/ButtonLink';
import TableSticky from '@/components/ui/table-sticky/TableSticky';
import TextSimple from '@/components/ui/text/TextSimple';
import {
  clientStoresRoute,
  storeSellerCreateRoute,
} from '@/utils/store-seller-routes';

export default {
  name: 'StoreSellersPage',
  components: {
    TextSimple,
    TableSticky,
    ButtonLink,
    PageLoader,
    PageHeader,
    PageBack,
  },
  computed: {
    ...mapState(['sellers', 'sellerLoading']),
    clientId() {
      return this.$route.params.id;
    },
    listRoute() {
      return clientStoresRoute(this.clientId);
    },
    createRoute() {
      return storeSellerCreateRoute(this.clientId);
    },
    listQuery() {
      return {
        clientId: this.clientId,
        page: Number(this.$route.query.page) || 1,
        itemsPerPage: Number(this.$route.query.limit) || 10,
      };
    },
    fields() {
      const clientId = this.clientId;
      return [
        {
          key: 'id',
          type: 'eye',
          route: 'client-store-seller-edit',
          param: 'sellerId',
          routeParams: { id: clientId },
          size: 'xs',
        },
        { key: 'firstname', size: 'm' },
        { key: 'lastname', size: 'm' },
        { key: 'email', size: 'xl' },
        { key: 'storesLabel', size: 'l', translationKey: 'stores' },
        {
          key: 'tradeInsCount',
          size: 's',
          translation: 'store-sellers.tradeInsCount',
        },
      ];
    },
  },
  watch: {
    listQuery: {
      immediate: true,
      handler(query) {
        if (query.clientId) {
          this.fetchSellers(query);
        }
      },
    },
  },
  methods: {
    ...mapActions(['fetchSellers']),
  },
};
</script>
